let _ = require('lodash');
let treeHelper = require('../../helpers/tree');
let { clearFilter } = require('./filterable-tree');

const BASE_PATH = ['order', 'branches', 'tree'];
const ORIGINAL_DATA_PATH = ['order', 'originalParameters', 'branches'];

module.exports = {
    initTreeState (args, state) {
        treeHelper.initTreeUiState(state, ORIGINAL_DATA_PATH, BASE_PATH);
    },

    changeValue ({ path, value }, state) {
        treeHelper.changeTreeNodeValue(
            state,
            ORIGINAL_DATA_PATH,
            BASE_PATH,
            path,
            value);
    },

    setSelection ({ value, filter }, state) {
        treeHelper.setValueByFilter(
            state,
            ORIGINAL_DATA_PATH,
            BASE_PATH,
            value,
            filter);
    },

    /***
     * Эта функция создаёт фильтр, который позволит перенести данные из дерева Проектов в дерево Городов
     * @param args
     * @param state
     */
    getCitiesTreeFilter (args, state) {
        let leafs = state.get(BASE_PATH.concat('computed', 'leafs'));
        let selected = state.get(BASE_PATH.concat('selected'));
        let selectedBranches = treeHelper.getSelectedLeafs(leafs, selected);
        let calcOnlyDefaultCities = state.get(['order', 'cities', 'calcOnlyDefaultCities']);
        if (calcOnlyDefaultCities) {
            let originalBranches = state.get(['order', 'originalParameters', 'branches']);
            let selectedCities =
                _.map(_.filter(originalBranches, x => selectedBranches.includes(x.code)), x => x.defaultCityId);

            args.filter = node => {
                if (node.branchId) {
                    return selectedCities.includes(node.code);
                }
                return false;
            };
        } else {
            args.filter = node => {
                if (node.branchId) {
                    return selectedBranches.includes(node.branchId.toString());
                }
                return false;
            };
        }
    },

    setAll ({ value }, state) {
        treeHelper.setAllSelection(state, ORIGINAL_DATA_PATH, BASE_PATH, value);
    },

    clearFilter (args, state) {
        treeHelper.clearFilter(state, BASE_PATH, 'branches')
    }
};




// WEBPACK FOOTER //
// ./actions/custom-order/branches.js